export const testUrl  = `/test`;
export const startTestUrl  = `/test/start`;
export const testResultUrl  = `/test/result`;
export const testResultUrlWithTypeAndSession  = `/test/result/:type/:sessionId`;
export const homeUrl  = `/`;
export const notFoundUrl  = `/404`;
export const impressUrl  = `/more/impress`;
export const privacyPolicyUrl  = `/more/privacypolicy`;